"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decreaseScreenShare = decreaseScreenShare;
exports.increaseScreenShare = increaseScreenShare;
exports.setScreenShare = setScreenShare;
var _constants = require("@studio/constants");
var _types = require("./types");
/**
 * @param {boolean} resetCountBasedOnBroadcastSources
 * @param {number} value
 */
function setScreenShare() {
  var resetCountBasedOnBroadcastSources = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var value = arguments.length > 1 ? arguments[1] : undefined;
  return function (dispatch, getState) {
    var _getState = getState(),
      sources = _getState.broadcastSources.sources,
      screenShareCount = _getState.screenShareCount;
    var updatedCount = 0;
    if (resetCountBasedOnBroadcastSources) {
      var screenSources = sources === null || sources === void 0 ? void 0 : sources.filter(function (source) {
        return source.value !== _constants.UNASSIGNED && source.type === _constants.SCREEN_PRESENTER;
      });
      updatedCount = screenSources.length;
    } else {
      updatedCount = value + screenShareCount;
      if (updatedCount > 2 || updatedCount < 0) return;
    }
    var action = {
      payload: updatedCount,
      type: _types.BROADCAST_SET_SCREEN_SHARE_COUNT
    };
    dispatch(action);
  };
}
function increaseScreenShare() {
  return setScreenShare(false, 1);
}
function decreaseScreenShare() {
  return setScreenShare(false, -1);
}